module.exports = __webpack_public_path__ + "static/googlePlayWhiteDeu-991c046c75398524ff4505b65e0da975.svg";